var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useRoute } from 'ziggy-js';
import PetSelect from '../Partials/PetSelect';
import _ from "lodash";
import { useUnsavedChanges } from "../../../Utils/handleUnsavedChanges";
import useForm from "../../../Utils/useForm";
import StepLayout from "./StepLayout";
import { PetCard, PetCardForm } from "../../Pet/Partials/PetCard";
import { Ziggy } from "@/ziggy";
import { Button } from "@/components/ui/button";
export default function PetStep(_a) {
    var certificate = _a.certificate, team = _a.team, branch = _a.branch, breeds = _a.breeds, colours = _a.colours;
    var route = useRoute(Ziggy);
    var _b = useState(JSON.parse(JSON.stringify(certificate))), originalData = _b[0], setOriginalData = _b[1];
    var form = useForm(__assign(__assign({}, certificate), { _step: 3 }));
    var _c = useUnsavedChanges(form), handleUnsaved = _c[0], removeHandleUnsaved = _c[1];
    useEffect(function () {
        console.log('PetStep useEffect...');
        form.setData(__assign(__assign({}, form.data), certificate));
    }, [certificate]);
    useEffect(function () {
        handleUnsaved(function () {
            return !_.isEqual(originalData.certificate_pets.map(function (a) { return a.id; }), form.data.certificate_pets.map(function (a) { return a.id; }));
        });
        return function () {
            removeHandleUnsaved();
        };
    });
    function submit() {
        form.put(route('team.branch.certificate.update', { team: team, branch: branch, certificate: certificate }), {
            errorBag: 'updateBranch',
            preserveScroll: true,
        });
    }
    function uniques(pets) {
        var result = [];
        var map = {};
        for (var _i = 0, pets_1 = pets; _i < pets_1.length; _i++) {
            var item = pets_1[_i];
            map[item.pet_id] = item;
        }
        _.forEach(map, function (item) {
            result.push(item);
        });
        return result;
    }
    function onPetChange(pet) {
        console.log('onPetChange...', pet);
        if (pet.id === '_NEW_') {
            form.data.certificate_pets.push({
                pet_id: "_NEW_",
                pet: {
                    $editing: true
                }
            });
            // prepend to certificate_pets
            form.data.certificate_pets = __spreadArray([form.data.certificate_pets[form.data.certificate_pets.length - 1]], form.data.certificate_pets.slice(0, form.data.certificate_pets.length - 1), true);
            form.setData('certificate_pets', form.data.certificate_pets);
        }
        else {
            form.data.certificate_pets.push({
                pet_id: pet.id,
                pet: pet
            });
            form.data.certificate_pets = uniques(form.data.certificate_pets);
            form.setData('certificate_pets', form.data.certificate_pets);
        }
    }
    function removePet(idx) {
        console.log('removePet', idx);
        form.data.certificate_pets.splice(idx, 1);
        form.setData('certificate_pets', form.data.certificate_pets);
    }
    return (_jsxs(StepLayout, __assign({ team: team, branch: branch, certificate: certificate, form: form }, { children: [certificate.client && _jsx("div", { children: _jsx(PetSelect, { onChange: onPetChange, form: form, pets: certificate.client.pets }) }), !certificate.client && _jsx("div", { children: "Select a client first..." }), form.data.certificate_pets.map(function (certificatePet, petIdx) {
                return _jsxs("div", __assign({ id: "pet-" + petIdx, className: "mt-6" }, { children: [!certificatePet.pet.$editing && _jsx(PetCard, { pet: certificatePet.pet, deletePet: function () { return removePet(petIdx); }, setEditing: function (editing) {
                                certificatePet.pet.$editing = editing;
                                form.setData('certificate_pets', form.data.certificate_pets);
                                if (!editing && !certificatePet.pet.id) {
                                    removePet(petIdx);
                                }
                            } }), certificatePet.pet.$editing && _jsx(PetCardForm, { team: team, branch: branch, client: certificate.client, pet: certificatePet.pet, colours: colours, breeds: breeds, setEditing: function (editing) {
                                certificatePet.pet.$editing = editing;
                                form.setData('certificate_pets', form.data.certificate_pets);
                                if (!editing && !certificatePet.pet.id) {
                                    removePet(petIdx);
                                }
                            }, onSave: function (pet) {
                                console.log('onChange', pet);
                                form.data.certificate_pets[petIdx].pet = pet;
                                form.data.certificate_pets[petIdx].pet_id = pet.id;
                                form.setData('certificate_pets', form.data.certificate_pets);
                            } })] }), certificatePet.pet.id);
            }), form.data.certificate_pets.length === 0 && _jsx("div", { children: _jsx("div", __assign({ className: "py-6" }, { children: _jsx("em", { children: "No pets selected..." }) })) }), _jsx(Button, __assign({ id: "continue", onClick: submit, className: "mt-6", processing: form.processing, disabled: form.processing ||
                    form.data.certificate_pets.filter(function (certificatePet) { return certificatePet.pet.$editing; }).length > 0 }, { children: "Save & continue" }))] })));
}
